---
layout: docs
title: "API Reference"
---


Corral exposes a comprehensive REST API for managing every aspect of the platform programmatically. The API is the same interface the admin console uses — anything you can do in the UI, you can do via API.

---

## Interactive Documentation

Every Corral instance includes a built-in interactive API reference powered by [Scalar](https://scalar.com/). Access it at `/scalar` on your instance (requires management access).

The Scalar page provides:

- **Two API documents**: `management.v0` (admin operations) and `consumer.v0` (end-user/agent operations)
- **Try it** — execute API calls directly against your instance from the browser
- **Request/response schemas** — full type definitions for every endpoint

---

## Authentication

API access uses OAuth 2.0 client credentials. See [Client Credentials & OAuth →](./client-credentials) for setup.

Include the bearer token in every request:

```
Authorization: Bearer {access_token}
```

---

## Key API Areas

The Scalar reference covers all endpoints in detail. Here's a high-level overview of what's available:

| Area | What You Can Do |
|---|---|
| **Projects** | Create, list, and manage root projects and projects |
| **Apps (Agents)** | Create, configure, publish, and version agents |
| **Intelligence** | Configure models and AI provider settings |
| **Connections** | Manage MCP servers and OpenAPI integrations |
| **Channels** | Configure Teams, widget, and other delivery channels |
| **Analytics** | Query conversation summaries, token usage, tool calls, and usage patterns |
| **Client Credentials** | Create and rotate service-to-service credentials |
| **Permissions** | Manage user, application, and invitation permissions per node |

---

## Real-Time Events

In addition to the REST API, Corral provides real-time events via SignalR:

- **Job progress** — background job status updates
- **Permission refresh** — permission change notifications
- **Notifications** — system notifications
- **File changes** — workspace file system updates

<!-- TODO: SignalR hub URL, connection details, and event schemas for developers building custom clients. -->
